import * as React from 'react';
import Note from "../../../../model/note/Note";
import {RouteComponentProps, withRouter} from "react-router";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import UserMention from "../../../mention/UserMention";
import DateUtils from "../../../../utils/DateUtils";
import {RootState} from "../../../../store/reducer/root/RootState";
import {Dispatch} from "redux";
import Toast from "../../../helper/Toast";
import {deleteJobNote, modifyPinningOnJobNote} from "../../../../store/action/note/notes";
import {connect} from "react-redux";
import IconSmall from "../../../../hiberUiKit/src/atoms/Icon/IconSmall";
import CommonStreamItem, {StreamItemAction} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import moment = require("moment");
import {option, Option} from "ts-option";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";

interface ReduxProps {
	/**
	 * Logged user id
	 */
	loggedUserId: string,
	/**
	 * Job id
	 */
	jobId: Option<string>,
}

interface ComponentProps {
	/**
	 * Job activity to display.
	 */
	activity: Note;
	/**
	 * Indicates if history item is active.
	 */
	isActive: boolean;
	/**
	 * On edit note click.
	 * @param {Note} note note to edit.
	 */
	onEditNoteClick?: (note: Note) => void;
	/**
	 * Indicates if action are disabled
	 */
	readOnly?: boolean
}

interface DispatchProps {
	/**
	 * Delete note action.
	 * @param {string} noteId note identifier.
	 * @param {string} jobId job identifier.
	 */
	deleteNote: (noteId: string, jobId: string, type: "note" | "reminder") => void
	/**
	 * Pin / unpin note action
	 * @param {string} noteId
	 * @param {string} jobId
	 * @param {boolean} pinned
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	modifyPinningOnJobNote: (noteId: string, jobId: string, pinned: boolean, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface RouteProps {
	jobReferenceNumber: string
}

type Props = ComponentProps & ReduxProps & DispatchProps & RouteComponentProps<RouteProps>;

class JobActivityNoteItem extends React.Component<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.deleteNoteClick = this.deleteNoteClick.bind(this);
		this.editNoteClick = this.editNoteClick.bind(this);
		this.renderBodyMessage = this.renderBodyMessage.bind(this);
		this.renderExtraMessage = this.renderExtraMessage.bind(this);
		this.unpinNoteClick = this.unpinNoteClick.bind(this);
		this.pinNoteClick = this.pinNoteClick.bind(this);
	}

	render() {
		let actions:StreamItemAction[] = [];
		if(this.props.activity.creator.id === this.props.loggedUserId && !this.props.readOnly) {
			actions.push(StreamItemAction.new("Edit", this.editNoteClick));
			actions.push(StreamItemAction.new("Delete", this.deleteNoteClick));
			if(!this.props.activity.isReminder() && this.props.activity.pinningData.pinned) {
				actions.push(StreamItemAction.new("Un-pin", this.unpinNoteClick));
			} else if (!this.props.activity.isReminder() && !this.props.activity.pinningData.pinned) {
				actions.push(StreamItemAction.new("Pin to top", this.pinNoteClick));
			}
		}
		return (
			<CommonStreamItem event={this.props.activity}
							  actions={actions}
							  renderBodyMessage={this.renderBodyMessage}
							  renderExtraMessage={this.renderExtraMessage}/>
		);
	}

	renderBodyMessage() {
		return (
			<UserMention value={this.props.activity.extendedContent} readonly/>
		)
	}

	renderExtraMessage() {
		return (
			<React.Fragment>
				{this.props.activity.reminderDate.map(date => {
					return date.isAfter(moment()) ? (
						<div className={"m-stream-item_body_reminder"}>
							<IconSmall icon={Icon.Reminder}/> {date.format(DateUtils.DATE_TIME_FORMAT)}
						</div>
					) : "";
				}).orNull}
			</React.Fragment>
		);
	}

	deleteNoteClick() {
		this.props.deleteNote(this.props.activity.id, this.props.jobId.getOrElse(""),
			this.props.activity.reminderDate.isDefined ? "reminder" : "note");
	}

	editNoteClick() {
		this.props.onEditNoteClick && this.props.onEditNoteClick(this.props.activity);
	}

	unpinNoteClick() {
		this.props.modifyPinningOnJobNote(this.props.activity.id, this.props.jobId.getOrElse(''), false,
			() => Toast.success("Note unpinned successfully.", "Unpin note"),
			(err) => notifyBugsnagAndShowToast(err, 'Unpin note'));
	}

	pinNoteClick() {
		this.props.modifyPinningOnJobNote(this.props.activity.id, this.props.jobId.getOrElse(''), true,
			() => Toast.success("Note pinned successfully.", "Pin note"),
			(err) => notifyBugsnagAndShowToast(err, 'Pin note'));
	}
}

function mapStateToProps(state: RootState, props: Props) {
	const {jobReferenceNumber} = props.match.params;
	const jobId = option(state.job.jobsMap[jobReferenceNumber]).map(job => job.id);
	return {
		loggedUserId: state.user.user.get.id,
		jobId,
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		deleteNote: (noteId: string, jobId: string, type: "note" | "reminder") => dispatch(
			deleteJobNote(noteId, jobId,
				() => {Toast.info(`${type} has been deleted`.capitalize(), `Delete ${type}`)},
				() => {Toast.info("Something went wrong. Please try again later.", "Delete note")})
		),
		modifyPinningOnJobNote: (noteId: string, jobId: string, pinned: boolean, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			modifyPinningOnJobNote(noteId, jobId, pinned, onSuccess, onFailure)
		)
	}
}

export default withRouter<ComponentProps>(connect(mapStateToProps, mapDispatchToProps)(JobActivityNoteItem));